
import { useState } from "react"
import { ADD_AND_FILL_FORM } from "../../../repository/patient-form"
import { toast } from "react-toastify"
import { MEDICAL_DETAILS } from "../../../repository/setup"

const useAddAndFillForm = () => {
    const [spinner, setSpinner] = useState(false)
    const [addAndFillFormModal, setaddAndFillFormModal] = useState({ data: null, open: false })
    const [fields, setFields] = useState([])

    const getFormDetails = async (id) => {
        try {
            setSpinner(true)
            let response = await MEDICAL_DETAILS(id)
            const formData = response?.data?.fields;
            const initialFields = formData.map((item) => {
                return { ...item, answer: (item.type === "Text" || item.type === "Title" || item.type === "Date") ? "" : [] }
            });
            setFields(initialFields);

        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }
    const handleInputChange = (event, fieldId) => {
        const { value } = event.target;
        setFields((prevFields) =>
            prevFields.map((field) =>
                field.id === fieldId ? { ...field, answer: +value } : field
            )
        );
    };

    const handleDateChange = (date, fieldId) => {
        setFields((prevFields) =>
            prevFields.map((field) =>
                field.id === fieldId ? { ...field, answer: date } : field
            )
        );
    };
    const handleRadioChange = (e, fieldId) => {
        const { value } = e.target;
        setFields((prevFields) =>
            prevFields.map((field) =>
                field.id === fieldId ? { ...field, answer: +value } : field
            )
        );
    };
    const handleCheckboxChange = (e, option, fieldId) => {
        setFields((prevFields) => {
            const { checked } = e.target
            let preData = [...prevFields]?.map((field) => {
                if (field.id === fieldId) {
                    return { ...field, answer: checked ? [...field.answer, option?.id] : [...field.answer]?.filter((cur) => cur !== option?.id) }
                }
                else return field
            })
            return preData
        })
    };

    const handleTextChange = (e, fieldId) => {
        const { value } = e.target;
        setFields((prevFields) =>
            prevFields.map((field) =>
                field.id === fieldId ? { ...field, answer: value } : field
            )
        );
    };

    const handleSubmit = async (patientId, form_List) => {
        const answers = fields?.map((cur) => {

            return { fieldId: cur?.id, answer: cur?.answer }
        })
        const submissionData = {
            formId: addAndFillFormModal?.data?.id,
            filledPercentage: calculateFilledPercentage(),
            answers: answers,
            patientId: patientId
        };

        try {
            setSpinner(true)
            let response = await ADD_AND_FILL_FORM(submissionData)
            toast.success(response?.message)
            setaddAndFillFormModal({ data: null, open: false })
            form_List()

        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    };

    // Example function to calculate filled percentage
    const calculateFilledPercentage = () => {
        const totalFields = fields.length;
        const fillFields = fields.filter((cur) => cur?.answer?.length > 0 || (cur.type === "Date" && cur?.answer))?.length
        let Percentage = totalFields > 0 ? (fillFields / totalFields) * 100 : 0;
        return Number(Percentage?.toFixed(2))
    };


    return {
        methods: {
            getFormDetails,
            setaddAndFillFormModal,
            handleTextChange,
            handleSubmit,
            handleDateChange,
            handleRadioChange,
            handleCheckboxChange,
            // -----------------------Form methods ---------------
            setFields,
            handleInputChange,
        },
        data: {
            spinner,
            addAndFillFormModal,
            fields,
        }
    }
}

export default useAddAndFillForm